/* Raine & Co brand and journal pages: journal search and topics, lookbook pins and "add the look", article contents
   list, product grids with quick add, and enquiry form checks. Content is server rendered; this only adds behaviour.
   Uses window.RC from theme.js (products, cart, fmt, esc, svg, initReveal). */
(function () {
  'use strict';
  var D = document, W = window;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12h16M14 6l6 6-6 6"/></svg>';
  var BAG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5.5 8.5h13l-1 11.5h-11z"/><path d="M9 8.5V7a3 3 0 0 1 6 0v1.5"/></svg>';
  var TICK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12.5l5 5L20 6.5"/></svg>';
  var reduce = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function RC() { return W.RC || {}; }
  function esc(s) { return RC().esc ? RC().esc(s) : String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmt(c) { return RC().fmt ? RC().fmt(c) : 'R' + Math.round(c / 100); }
  function reveal() { if (RC().initReveal) RC().initReveal(); }
  function products() { return RC().products ? RC().products() : Promise.resolve([]); }
  function addToBag(variantId, qty, gift, title) {
    var items = [{ id: Number(variantId), quantity: qty || 1 }];
    if (gift && RC().giftBoxVariant) items.push({ id: Number(RC().giftBoxVariant), quantity: qty || 1, properties: { For: title } });
    if (!RC().cart) return Promise.resolve();
    return RC().cart.add(items); // add() refreshes and opens the bag drawer
  }

  /* ---------- journal: topics and search filter the cards in the page ---------- */
  var grid = $('#j-grid');
  if (grid && $('#j-chips')) {
    var input = $('#j-q'), clear = $('#j-clear'), feat = $('#j-feat'), none = $('#j-none'), topic = 'All', q = '';
    var tagged = /\/tagged\//.test(location.pathname);
    var pressed = $('#j-chips [aria-pressed="true"]'); if (pressed) topic = pressed.getAttribute('data-topic');
    var cards = function () { return $$('.post', grid); };
    var draw = function () {
      var filtering = !!q || (!tagged && topic !== 'All');
      if (feat) feat.hidden = filtering;
      $$('[data-feat-card]', grid).forEach(function (w) { w.hidden = !filtering; });
      var n = 0;
      cards().forEach(function (c) {
        var wrapHidden = c.parentNode.hasAttribute('data-feat-card') && !filtering;
        var ok = (tagged || topic === 'All' || c.getAttribute('data-topic') === topic) &&
          (!q || q.split(/\s+/).every(function (t) { return (c.getAttribute('data-text') || '').indexOf(t) > -1; }));
        c.hidden = !ok;
        if (ok && !wrapHidden) n++;
      });
      var h = $('#h-latest'); if (h && !tagged) h.textContent = filtering ? (q ? 'Search results' : topic) : 'Latest articles';
      $('#j-count').textContent = n + (n === 1 ? ' article' : ' articles');
      if (none) { none.hidden = n > 0; var t = $('#j-none-t'); if (t) t.textContent = 'No articles match "' + (input.value.trim() || topic) + '"'; }
      if (clear) clear.hidden = !input.value;
    };
    $$('#j-chips button').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = b.getAttribute('data-topic');
        if (tagged) { var base = location.pathname.split('/tagged/')[0]; location.href = t === 'All' ? base : base + '/tagged/' + t.toLowerCase().replace(/[^a-z0-9]+/g, '-'); return; }
        topic = t;
        $$('#j-chips button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        draw();
      });
    });
    input.addEventListener('input', function () { q = input.value.toLowerCase().trim(); draw(); });
    $('#j-search').addEventListener('submit', function (e) { e.preventDefault(); var t = $('#h-latest'); if (t) t.scrollIntoView({ block: 'start' }); });
    if (clear) clear.addEventListener('click', function () { input.value = ''; q = ''; draw(); input.focus(); });
    var reset = $('#j-reset');
    if (reset) reset.addEventListener('click', function () {
      input.value = ''; q = ''; topic = 'All';
      $$('#j-chips button').forEach(function (x) { x.setAttribute('aria-pressed', String(x.getAttribute('data-topic') === 'All')); });
      draw();
    });
  }

  /* ---------- lookbook: numbers on the photographs, "add the look", growing dividers ---------- */
  var looks = $('#looks');
  if (looks) {
    looks.addEventListener('click', function (e) {
      var pin = e.target.closest('.pin');
      if (pin) {
        var sec = pin.closest('.look'), i = pin.getAttribute('data-i');
        $$('.lk-items li', sec).forEach(function (li) { li.classList.toggle('hl', li.getAttribute('data-i') === i); });
        $$('.pin', sec).forEach(function (b) { b.setAttribute('aria-pressed', String(b === pin)); });
        return;
      }
      var add = e.target.closest('[data-addlook]');
      if (add) {
        var items = $$('.lk-items li', add.closest('.look')).filter(function (li) { return li.getAttribute('data-available') !== 'false'; })
          .map(function (li) { return { id: Number(li.getAttribute('data-variant')), quantity: 1 }; });
        if (!items.length || !RC().cart) return;
        add.disabled = true;
        RC().cart.add(items).catch(function () {}).then(function () { add.disabled = false; });
      }
    });
    looks.addEventListener('mouseover', function (e) {
      var li = e.target.closest('.lk-items li'); if (!li) return;
      $$('.pin', li.closest('.look')).forEach(function (b) { b.classList.toggle('lit', b.getAttribute('data-i') === li.getAttribute('data-i')); });
    });
    var divs = $$('.lk-div', looks);
    if (reduce || !('IntersectionObserver' in W)) divs.forEach(function (d) { d.classList.add('on'); });
    else {
      var io = new IntersectionObserver(function (en) { en.forEach(function (x) { x.target.classList.toggle('on', x.isIntersecting); }); }, { rootMargin: '-22% 0px -22% 0px', threshold: 0 });
      divs.forEach(function (d) { io.observe(d); });
    }
  }

  /* ---------- quick add (article product grids) ---------- */
  var qa = { last: null };
  function openQuick(p, trigger) {
    var el = $('#qa'), box = $('#qa-in'); if (!el || !p) return;
    var vs = p.variants || [];
    var sized = p.sized && vs.length > 1;
    var vi = sized ? Math.min(1, vs.length - 1) : 0, qty = 1;
    var pay = fmt(Math.round(p.price / 4));
    box.innerHTML = '<div class="qa-grid"><div class="qa-im"><img src="' + esc(p.img) + '" alt="' + esc(p.title) + '"></div><div class="qa-d">' +
      '<h2 id="qa-t">' + esc(p.title) + '</h2><p class="qa-pr"><span class="price">' + fmt(p.price) + '</span> <span class="qa-pf">or 4 payments of ' + pay + ' with Payflex</span></p>' +
      '<p class="qa-desc" id="qa-desc">' + esc([p.sub, p.size].filter(Boolean).join(', ')) + '</p>' +
      (sized ? '<div class="qa-opt"><p class="qa-l">Ring size: <b id="qa-size">' + esc(vs[vi].title) + '</b> <a href="/pages/ring-size-guide" target="_blank" rel="noopener">Size guide</a></p><div class="pills" role="radiogroup" aria-label="Ring size">' +
        vs.map(function (v, i) { return '<button type="button" class="pill" role="radio" data-vi="' + i + '" aria-checked="' + (i === vi) + '"' + (v.available === false ? ' disabled' : '') + '>' + esc(v.title) + '</button>'; }).join('') + '</div></div>' : '') +
      '<div class="qa-opt"><p class="qa-l">Quantity</p><div class="qty" role="group" aria-label="Quantity"><button type="button" data-q="-1" aria-label="Decrease quantity">&minus;</button><span id="qa-n">1</span><button type="button" data-q="1" aria-label="Increase quantity">+</button></div></div>' +
      '<label class="giftbox"><input type="checkbox" id="qa-gift"><span class="bx">' + TICK + '</span><span>Add a gift box</span><em>+ ' + fmt(4900) + '</em></label>' +
      '<button class="btn btn-ink qa-add" type="button" id="qa-add"' + (p.available === false ? ' disabled' : '') + '>' + (p.available === false ? 'Sold out' : 'Add to bag') + '</button><a class="link-line qa-more" href="' + esc(p.url) + '">View full details ' + ARROW + '</a></div></div>';
    fetch(p.url + '.js').then(function (r) { return r.json(); }).then(function (j) {
      var t = D.createElement('div'); t.innerHTML = j.description || ''; var txt = t.textContent.trim();
      var d = $('#qa-desc'); if (d && txt) d.textContent = txt;
    }).catch(function () {});
    box.onclick = function (e) {
      var pb = e.target.closest('[data-vi]');
      if (pb) { vi = Number(pb.getAttribute('data-vi')); $$('[data-vi]', box).forEach(function (x) { x.setAttribute('aria-checked', String(x === pb)); }); $('#qa-size').textContent = vs[vi].title; }
      var qb = e.target.closest('[data-q]');
      if (qb) { qty = Math.max(1, Math.min(9, qty + Number(qb.getAttribute('data-q')))); $('#qa-n').textContent = qty; }
      if (e.target.closest('#qa-add')) {
        var gift = $('#qa-gift').checked;
        closeQuick(true);
        addToBag(vs[vi].id, qty, gift, p.title);
      }
    };
    qa.last = trigger || D.activeElement;
    el.hidden = false; $('#qa-s').hidden = false;
    requestAnimationFrame(function () { el.classList.add('open'); $('#qa-s').classList.add('open'); });
    D.body.style.overflow = 'hidden';
    setTimeout(function () { var f = $('#qa-x'); if (f) f.focus(); }, 40);
  }
  function closeQuick(silent) {
    var el = $('#qa'); if (!el || el.hidden) return;
    el.classList.remove('open'); $('#qa-s').classList.remove('open');
    el.hidden = true; $('#qa-s').hidden = true;
    D.body.style.overflow = '';
    if (!silent && qa.last && qa.last.focus) qa.last.focus();
  }

  /* ---------- article ---------- */
  var body = $('#a-body');
  if (body) {
    // contents list from the h2s, with the section being read in bold
    var hs = $$('h2', body), toc = $('.a-toc');
    hs.forEach(function (h, i) { if (!h.id) h.id = 's' + (i + 1); });
    var items = hs.map(function (h) { return '<li><a href="#' + h.id + '" data-to="' + h.id + '">' + esc(h.textContent) + '</a></li>'; }).join('');
    $('#a-toc').innerHTML = items; $('#a-toc-m').innerHTML = items;
    if (toc) toc.hidden = !hs.length;
    var hh = function () { var h = $('.site-header'); return (h ? h.offsetHeight : 80) + 24; };
    var setActive = function (id) {
      $$('.a-toc [data-to]').forEach(function (x) { var on = x.getAttribute('data-to') === id; x.classList.toggle('on', on); if (on) x.setAttribute('aria-current', 'location'); else x.removeAttribute('aria-current'); });
    };
    if (toc) toc.addEventListener('click', function (e) {
      var l = e.target.closest('[data-to]'); if (!l) return;
      e.preventDefault();
      var t = D.getElementById(l.getAttribute('data-to'));
      W.scrollTo({ top: t.getBoundingClientRect().top + W.pageYOffset - hh(), behavior: reduce ? 'auto' : 'smooth' });
      var m = $('#toc-m'); if (m) m.open = false;
      setActive(l.getAttribute('data-to'));
    });
    var spy = function () {
      if (!hs.length) return;
      var line = hh() + 40, cur = hs[0].id;
      hs.forEach(function (h) { if (h.getBoundingClientRect().top <= line) cur = h.id; });
      setActive(cur);
    };
    W.addEventListener('scroll', spy, { passive: true }); spy();

    // product grids in the article and the 'Shop the article' list
    var blocks = $$('[data-handles]', body);
    if (blocks.length) {
      products().then(function (all) {
        var by = {}; all.forEach(function (p) { by[p.handle] = p; });
        blocks.forEach(function (el) {
          var list = el.getAttribute('data-handles').split(',').map(function (h) { return by[h.trim()]; }).filter(Boolean).slice(0, Number(el.getAttribute('data-limit')) || 3);
          var g = $('.bgrid', el) || el;
          g.className = 'sb-grid';
          g.innerHTML = list.map(function (p) {
            return '<article class="sb-card"><a class="sb-im" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(p.img) + '" alt="" loading="lazy"></a>' +
              '<div class="sb-b"><h4><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h4><p class="sb-pr">' + fmt(p.price) + '</p>' +
              '<button class="sb-add" type="button" data-qa="' + esc(p.handle) + '" aria-label="Add ' + esc(p.title) + ' to bag">' + BAG + '<span>Add to bag</span></button></div></article>';
          }).join('');
        });
        var first = blocks[0];
        var aside = first.getAttribute('data-handles').split(',').map(function (h) { return by[h.trim()]; }).filter(Boolean).slice(0, 4);
        $('#a-shop').innerHTML = aside.map(function (p) { return '<li><a href="' + esc(p.url) + '"><img src="' + esc(p.img) + '" alt="" loading="lazy"><span><b>' + esc(p.title) + '</b>' + fmt(p.price) + '</span></a><button class="sb-mini" type="button" data-qa="' + esc(p.handle) + '" aria-label="Add ' + esc(p.title) + ' to bag">Add</button></li>'; }).join('');
        $('#a-shopbox').hidden = !aside.length;
        D.addEventListener('click', function (e) {
          var b = e.target.closest('[data-qa]'); if (!b) return;
          e.preventDefault(); openQuick(by[b.getAttribute('data-qa')], b);
        });
      });
    }
    var qx = $('#qa-x'), qs = $('#qa-s');
    if (qx) qx.addEventListener('click', function () { closeQuick(); });
    if (qs) qs.addEventListener('click', function () { closeQuick(); });
    D.addEventListener('keydown', function (e) {
      var el = $('#qa'); if (!el || el.hidden) return;
      if (e.key === 'Escape') { e.stopPropagation(); closeQuick(); }
      if (e.key === 'Tab') {
        var f = $$('button, a[href], input', el).filter(function (n) { return n.offsetParent !== null; });
        if (!f.length) return; var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && D.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && D.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    });
  }

  /* ---------- enquiry form (corporate gifting): required fields before Shopify sends it ---------- */
  $$('form[data-check]').forEach(function (f) {
    if (f.classList.contains('hform') || f.querySelector('.field')) return; // help and legal forms are checked by their own scripts
    f.setAttribute('novalidate', '');
    f.addEventListener('submit', function (e) {
      $$('.f-err', f).forEach(function (n) { if (!n.hasAttribute('data-server')) n.remove(); });
      var bad = $$('[required]', f).filter(function (i) { return i.type === 'checkbox' ? !i.checked : !String(i.value).trim() || (i.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(i.value.trim())); });
      if (!bad.length) return;
      e.preventDefault();
      bad[0].focus();
      var anchor = bad[0].closest('label.chk') || bad[0];
      anchor.insertAdjacentHTML('afterend', '<p class="f-err" role="alert">Please complete this field.</p>');
    });
  });
  var ok = $('.f-ok');
  if (ok) { ok.focus(); ok.scrollIntoView({ block: 'center' }); }

  reveal();
})();
